export const AppUrls = {
  root: ['/'] as const,
  bookingNotFound: (salonId: string): string[] => ['/s', salonId, 'not-found'],
  salon: (salonId: string): string[] => ['/s', salonId],
  successBooking: (salonId: string): string[] => ['/s', salonId, 'success'],
  privacyPolicy: (salonId: string): string[] => ['/s', salonId, 'c', 'privacy-policy'],
  termsOfService: (salonId: string): string[] => ['/s', salonId, 'c', 'terms-of-service'],
} as const;

export type AppUrl = (typeof AppUrls)[keyof typeof AppUrls];
